<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog
      :title="isOld ? $t('servicesystem.common_objects.appointment.edit') : $t('servicesystem.common_objects.appointment.new')"
      :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger" :persistent="true"
      @close="($route.params && $route.params.appointmentId) ? $router.push({ params: { appointmentId: undefined } }) : null">
      <template v-slot:content>

        <div v-if="editObject" :key="'top' + dialogtrigger">
          <v-row v-if="!isAbsence" no-gutters style="background-color: #00000015;" class="pt-1">
            <v-col cols="auto" class="rounded-tab-spacer" style="width: 8px;">
            </v-col>
            <v-col cols="auto">
              <v-tabs background-color="transparent" class="mandatory" style="position: relative;" :hide-slider="true"
                height="36">
                <v-tab class="px-3 rounded-tab" :class="mode == 'appointment' ? 'flowout' : ''"
                  style="min-width: unset;" @click="mode = 'appointment'">
                  {{ $t('servicesystem.common_objects.appointment.appointment') }}
                </v-tab>
                <v-tab class="px-3 rounded-tab" :class="mode == 'job' ? 'flowout' : ''" style="min-width: unset;"
                  @click="mode = 'job'">
                  {{ $t('servicesystem.common_objects.job.job_details') }}
                </v-tab>
              </v-tabs>
            </v-col>
            <v-col cols="0" class="rounded-tab-spacer">
            </v-col>
          </v-row>

          <template v-if="mode == 'appointment'">
            <v-container class="pa-0" fluid>
              <v-row no-gutters v-if="isAbsence">
                <edit-li :label="$t('servicesystem.common_objects.appointment.types.label')"
                  :value="$t('servicesystem.common_objects.appointment.types.absence')">
                </edit-li>
                <QTextField v-model="editObject.Subject" :label="'Description'" class="mx-5" :rules="[requiredRule]"
                  externaledit>
                </QTextField>
              </v-row>
              <v-row no-gutters v-else>
                <v-col cols="8" class="px-5">
                  <div class="mb-0 mt-1">
                    <b style="font-size: 11.5px;">
                      {{ $t('servicesystem.common_objects.appointment.job_name') }}
                    </b>
                  </div>
                  <router-link :to="{
                    name: 'ViewJob', params: { filter: 'my', jobId: (JobDetails && JobDetails.Id) }
                  }" class="primary--text minimalLink" style="font-size: 13px;">
                    {{ JobDetails && JobDetails.DisplayName }}
                  </router-link>
                </v-col>
                <v-col cols="4">
                  <edit-li :label="$t('servicesystem.common_objects.appointment.estimated_time')"
                    :value="JobDetails && JobDetails.EstimatedTime ? JobDetails.EstimatedTime : null" class="pl-0">
                  </edit-li>
                </v-col>
              </v-row>
            </v-container>

            <select-li v-if="!isAbsence" :label="$t('servicesystem.common_objects.appointment.types.label')"
              :list="typeOptions" :value="1" :keyname="'Type'" :textkey="'text'" :valuekey="'value'" :edit="false"
              @fetch="updateValue">
              <!-- fix default value to be changeable -->
            </select-li>

            <v-text-field type="date" v-model="date" :label="$t('servicesystem.common_objects.appointment.start_date')"
              class="mx-2 my-1 mt-4" outlined dense hide-details>
            </v-text-field>

            <v-row no-gutters align="center">
              <v-text-field type="time" step="300" min="00:00"
                :label="$t('servicesystem.common_objects.appointment.start')" v-model="startTime" outlined hide-details
                dense class="mx-2 my-1">
              </v-text-field>

              <label>{{ hours }}</label>
              <v-text-field type="time" :label="$t('servicesystem.common_objects.appointment.end')" v-model="stopTime"
                outlined hide-details dense class="mx-2 my-1">
              </v-text-field>
            </v-row>

            <v-text-field type="date" v-model="date2" :label="$t('servicesystem.common_objects.appointment.end_date')"
              class="mx-2 my-1" outlined dense hide-details>
            </v-text-field>

            <user-list :key="dialogtrigger" :label="$t('servicesystem.common_objects.appointment.participants')"
              :filterhint="$t('servicesystem.common_objects.appointment.search_participants')" :value="participants"
              :items="availableUsers" :keyname="'Participants'" :edit="true" @fetch="updateValue">
            </user-list>
          </template>

          <template v-else>
            <v-container v-if="JobDetails">
              <v-row no-gutters>
                <v-col :cols="isPhoneBool ? 12 : 6" class="pr-3">
                  <v-row no-gutters align="center" justify="space-between">
                    <v-col class="py-2" cols="5">
                      {{ $t('servicesystem.common_objects.order.order_id') }}:
                    </v-col>
                    <v-col class="py-2" cols="7">
                      <b style="color: black;">
                        {{ (JobDetails.JobTypeId != 3 ? JobDetails.OrderId : ('S' + JobDetails.Id)) }}
                      </b>
                    </v-col>
                  </v-row>
                  <v-row no-gutters align="center" justify="space-between">
                    <v-col class="py-2" cols="5">
                      {{ $t("servicesystem.common_objects.job.status") }}:
                    </v-col>
                    <v-col class="py-2" cols="7">
                      <v-chip small
                        :style="'background-color: ' + statuscolor(JobDetails.JobStatusId) + '; color: white;'"
                        style="border-radius: 4px;">
                        {{ JobDetails.JobStatus.Name }}
                      </v-chip>
                      <!-- 
                        <v-chip v-if="JobDetails.JobSubStatus" small
                          :style="'background-color: ' + statuscolor(JobDetails.JobStatusId) + '; color: white;'"
                          style="border-radius: 4px;" class="ml-n2 pl-4 truncate--text">
                          {{ JobDetails.JobSubStatus.Name }}
                        </v-chip>
                        -->
                    </v-col>
                  </v-row>
                  <v-row no-gutters align="center" justify="space-between">
                    <v-col class="py-2" cols="5">
                      {{ $t("servicesystem.common_objects.job.type") }}:
                    </v-col>
                    <v-col class="py-2" cols="7">
                      <v-chip small style="border-radius: 4px;">
                        {{ JobDetails.JobType.Name }}
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-row no-gutters align="center" justify="space-between">
                    <v-col class="py-2" cols="5">
                      {{ $t("servicesystem.common_objects.job.created") }}:
                    </v-col>
                    <v-col class="py-2" cols="7">
                      {{ i18nFormatDateTime(JobDetails.CreatedDate) }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters align="center" justify="space-between">
                    <v-col class="py-2" cols="5">
                      {{ $t("servicesystem.common_objects.job.priority") }}:
                    </v-col>
                    <v-col class="py-2" cols="7">
                      {{ JobDetails.JobPriority.Name }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col :cols="isPhoneBool ? 12 : 6">
                  <p class="mb-n2">
                    <b style="font-size: 11.5px;">
                      {{ $t("servicesystem.common_objects.customer.customer") }}
                    </b>
                  </p>
                  <CustomerListItem :item="JobDetails.Customer" singleline class="mb-1 ml-n4"
                    @click="openCustomer(JobDetails.CustomerId)">
                  </CustomerListItem>
                  <v-card flat outlined class="pa-2">
                    <b style="font-size: 11.5px;">
                      {{ $t("servicesystem.common_objects.address.delivery_address") }}
                    </b>
                    <div>{{ JobDetails.DeliveryAddress.Street }}</div>
                    <div>{{ JobDetails.DeliveryAddress.Zip }} {{ JobDetails.DeliveryAddress.City }}</div>
                    <div>{{ JobDetails.DeliveryAddress.Country }}</div>
                  </v-card>
                </v-col>
              </v-row>

              <v-row no-gutters v-if="JobDetails.FirstLineComment" class="mt-2">
                <v-col class="pa-2" style="background-color: #fbf5b8; border-radius: 6px;">
                  <b style="font-size: 11.5px;">
                    {{ $t('servicesystem.common_objects.job.first_line_comment') }}
                  </b>
                  <div style="font-size: 13px; max-height: 187px; overflow-y: auto; white-space: pre-wrap;">
                    {{ JobDetails.FirstLineComment || 'Not provided' }}
                  </div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mt-4">
                <v-col v-if="JobDetails.InverseParent" :cols="12">
                  <v-row v-if="JobDetails.InverseParent.length > 1" no-gutters align="center">
                    <v-col cols="auto" class="pr-3">
                      <b>{{ $t("servicesystem.common_objects.machine.machines") }} ({{ JobDetails.InverseParent.length
                      }})</b>
                    </v-col>
                    <v-divider />
                  </v-row>
                  <div v-for="(machineJob, index) in JobDetails.InverseParent" :key="machineJob.Id">
                    <MachineListItem :machine="machineJob.Machine" class="ml-n5"
                      @select="openMachine(machineJob.Machine.Id)">
                    </MachineListItem>
                    <div>
                      <small>
                        <b>
                          {{ $t('servicesystem.common_objects.machine.edit.customer_comment') }}
                        </b>
                      </small>
                    </div>
                    <div style="font-size: 13px; max-height: 187px; overflow-y: auto; white-space: pre-wrap;">
                      {{ machineJob.CustomerComment }}
                    </div>
                    <div>
                      <small>
                        <b>
                          {{ $t('servicesystem.common_objects.machine.edit.invoice_comment') }}
                        </b>
                      </small>
                    </div>
                    <div style="font-size: 13px; max-height: 187px; overflow-y: auto; white-space: pre-wrap;">
                      {{ machineJob.InvoiceComment }}
                    </div>
                    <v-divider v-if="index < (JobDetails.InverseParent.length - 1)" class="my-2"></v-divider>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </div>
      </template>


      <template v-slot:buttons>
        <v-btn v-if="isOld" :color="!loading ? 'error' : 'disabled'" outlined :loading="deleteLoading"
          @click="!loading && !deleteLoading ? handleDelete() : null">
          {{ $t('servicesystem.common_objects.commonterms.delete') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="mr-2" @click="closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn @click="(valid && !deleteLoading) ? handleSave() : null" :loading="loading"
          :color="(valid && !deleteLoading) ? (isOld ? 'primary' : 'success') : 'disabled'">
          {{ !isOld ?
            $t('servicesystem.common_objects.commonterms.create') :
            $t('servicesystem.common_objects.commonterms.save')
          }}
        </v-btn>
      </template>

    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EditLi from "@/components/Inputs/EditableListItem.vue";
import SelectLi from "@/components/Inputs/SelectListItem.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import Vue from "vue";
//import DateLi from "@/components/Inputs/DateListItem.vue";
import AppointmentTypes from "@/api/Constants/appointment-types";
import CustomerListItem from "@/components/ListItems/CustomerListItem.vue";
import MachineListItem from "@/components/ListItems/MachineListItem.vue";
import UserList from "@/components/SingleUse/UserListListItem.vue";
import moment from "moment";

export default {
  name: "AppointmentDialog",
  props: ["externaltrigger", "appointmentitem", "JobDetails"],
  components: {
    SlottedDialog, EditLi, SelectLi,
    //DateLi,
    UserList,
    MachineListItem,
    CustomerListItem,
  },
  mixins: [clientAPI],

  data() {
    return {
      hours: 0,
      dialogtrigger: 0,
      closetrigger: 0,
      editObject: null,
      valid: false,
      loading: false,
      deleteLoading: false,
      bookableUsers: [],
      availableUsers: [],
      participants: [],
      typeOptions: AppointmentTypes,

      mode: 'appointment',
    };
  },

  mounted() {
    this.getBookable();
  },

  methods: {
    getBookable() {
      this.loading = true;
      this.getBookableUsers()
        .then((response) => {
          this.bookableUsers = response;
          this.availableUsers = Object.assign([], this.bookableUsers); //TODO: separate request
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },

    openCustomer(id) {
      this.$router.push({ name: "ViewCustomer", params: { customerId: id } });
    },

    openMachine(id) {
      this.$router.push({ name: "ViewMachine", params: { machineId: id } });
    },

    updateValue(update) {
      //console.log("Updatevalue", update);
      this.editObject[update.key] = update.value;
    },

    handleDelete() {
      this.deleteLoading = true;
      const id = this.editObject.Id;
      this.deleteAppointment(id)
        .then(() => {
          this.$emit("Delete", id);
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.deleteLoading = false;
        });
    },

    handleSave() {
      this.loading = true;
      //console.log('here');
      if (this.isOld) {
        this.change();
      } else {
        this.create();
      }
    },

    create() {
      var dto = Object.assign({}, this.editObject)
      //console.log("dto", dto);
      this.createAppointment(dto)
        .then((response) => {
          response.new = true;

          this.$emit("Update", response);
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },

    change() {
      var dto = Object.assign({}, this.editObject)
      this.changeAppointment(dto)
        .then((response) => {
          response.changed = true;
          this.$emit("Update", response);
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });

    },

    getHourDifferential(start, end) {
      const endDateTime = moment(end)
      const startDateTime = moment(start)
      var output = endDateTime.diff(startDateTime, 'hours', true).toFixed(2)
      return output;
    },

    parseItem(input) {
      this.mode = 'appointment';
      if (!input) {
        this.hours = this.JobDetails && this.JobDetails.EstimatedTime || 1;
        const defaultStartTime = moment().set("second", 0).set("minute", 0).add(1, 'hours')
        const defaultStopTime = moment().set("second", 0).set("minute", 0).add(this.hours + 1, 'hours')
        this.editObject = {
          JobId: this.$route.params.jobId,
          Type: 1,
          AppointmentDate: defaultStartTime,
          StartTime: defaultStartTime,
          EndTime: defaultStopTime,
        };
      }
      else {
        this.hours = this.getHourDifferential(input.StartTime, input.EndTime);
        this.editObject = Object.assign({}, input)
      }
      this.participants = [];
      if (input && input.Participants) {
        input.Participants.forEach((participant) => {
          var user = participant.User;
          user.old = true;
          this.participants.push(user);
        });
      }

    },
  },

  computed: {

    date: {
      get: function () {
        if (this.editObject?.AppointmentDate)
          return new Date(this.editObject.AppointmentDate).toISOString().substring(0, 10)

        return new Date().toISOString().substring(0, 10)
      },
      set: function (val) {
        this.editObject.AppointmentDate = new Date(val).toISOString().substring(0, 10);
        Vue.set(this.editObject, "StartTime", moment(this.date + ' ' + this.startTime));
        Vue.set(this.editObject, "EndTime", moment(this.editObject.StartTime).add(this.hours, 'hours'));
      }
    },

    startTime: {
      get: function () {
        var dateTime = moment().utc();
        if (this.editObject?.StartTime) {
          dateTime = moment.utc(this.editObject?.StartTime)
        }
        return dateTime.local().format("HH:mm");
      },
      set: function (val) {
        Vue.set(this.editObject, "StartTime", moment(this.date + ' ' + val));
        Vue.set(this.editObject, "EndTime", moment(this.editObject.StartTime).add(this.hours, 'hours'));
        //console.log(this.editObject);
      }
    },

    date2: {
      get: function () {
        if (this.editObject?.EndTime)
          return new Date(this.editObject.EndTime).toISOString().substring(0, 10)

        return this.editObject.EndTime;
      },
      set: function (val) {
        const time = this.stopTime;
        const newEnd = moment(val + ' ' + time);
        Vue.set(this.editObject, "EndTime", newEnd);
        this.hours = this.getHourDifferential(this.editObject.StartTime, newEnd);
      }
    },

    stopTime: {
      get: function () {
        var dateTime = moment.utc();
        if (this.editObject && this.editObject.EndTime) {
          dateTime = moment.utc(this.editObject.EndTime);
        }
         

        else if (this.editObject && this.editObject.StartTime) {
          dateTime = moment.utc(this.editObject.StartTime).add(this.hours, 'hours');
        }

        return dateTime.local().format("HH:mm");
      },
      set: function (val) {
        var endTime = moment(this.date + ' ' + val);

        var setDiffHours = this.getHourDifferential(this.editObject.StartTime, endTime);
        if (parseInt(setDiffHours) < 0) {
          endTime = moment(this.date + ' ' + val).add(1, 'days')
          setDiffHours = this.getHourDifferential(this.editObject.StartTime, endTime);
          this.hours = Math.abs(setDiffHours);
        }
        else {
          this.hours = setDiffHours
        }
        Vue.set(this.editObject, "EndTime", endTime);
      }
    },

    isAbsence() {
      return this.appointmentitem && this.appointmentitem.IsAbsence;
    },

    UserValue() {
      return this.editObject && this.editObject.User && this.editObject.User.Name
        ? this.editObject.User.Name
        : "Not set";
    },

    isOld() {
      return this.editObject && this.editObject.Id && this.editObject.Id > -1;
    },

    storeTrigger() {
      return this.$store.getters["triggerevents/AppointmentTrigger"];
    },
  },

  watch: {
    externaltrigger: function () {
      this.parseItem(this.appointmentitem);
      this.dialogtrigger++;
    },

    storeTrigger: function () {
      this.parseItem(null);
      this.dialogtrigger++;
    },

    appointmentitem: {
      deep: true,
      handler() {
        this.parseItem(this.appointmentitem);
      },
    },
    /*
        hours(val) {
          //console.log("HOURS:", val);
        },
    
        loading: function () {
          //console.log('loading', this.loading);
        }
    */
  },
};
</script>


<style lang="scss"></style>